import moment from "moment";

function formatDate(date, format, lang = "de") {
  if (!date) {
    return null;
  }
  moment.locale(lang);
  return moment(date).format(format);
}

export default formatDate;
